"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Box from "@mui/material/Box";
import Drawer, { drawerClasses } from "@mui/material/Drawer";

import { Logo } from "@onair/minimal-ui/logo";
import { Scrollbar } from "@onair/minimal-ui/scrollbar";
import { NavSectionVertical } from "@onair/minimal-ui/nav-section";
import type { NavSectionProps } from "@onair/minimal-ui/nav-section";

type NavMobileProps = NavSectionProps & {
	open: boolean;
	onClose: () => void;
	slots?: {
		topArea?: React.ReactNode;
		bottomArea?: React.ReactNode;
	};
};

export const NavMobile = ({
	data,
	open,
	onClose,
	slots,
	sx,
	...other
}: NavMobileProps) => {
	const pathname = usePathname();

	useEffect(() => {
		if (open) {
			onClose();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	return (
		<Drawer
			open={open}
			onClose={onClose}
			sx={{
				[`& .${drawerClasses.paper}`]: {
					overflow: "unset",
					width: "var(--layout-nav-mobile-width)",
					...sx,
				},
			}}
		>
			{slots?.topArea ?? (
				<Box sx={{ pl: 3.5, pt: 2.5, pb: 1 }}>
					<Logo />
				</Box>
			)}

			<Scrollbar fillContent>
				<NavSectionVertical
					data={data}
					sx={{ px: 2, flex: "1 1 auto" }}
					{...other}
				/>
			</Scrollbar>

			{slots?.bottomArea}
		</Drawer>
	);
};
